<script setup>
/**
 * "● PREVIEW  ‹scene›" / "● PROGRAM  ‹scene›": the same header for both
 * monitors, label and name on one baseline. `badges` sits right after the
 * name, `actions` on the far right.
 */
defineProps({
	label: { type: String, required: true },
	/** 'preview' (green) | 'program' (red) */
	tone: { type: String, default: 'preview' },
	name: { type: String, default: '' },
	placeholder: { type: String, default: '' },
	pulse: { type: Boolean, default: false },
	testid: { type: String, required: true },
})
</script>

<template>
	<header class="flex h-8 min-w-0 items-center gap-2" :data-testid="`${testid}-header`">
		<div class="flex min-w-0 flex-1 items-baseline gap-2.5">
			<span
				class="inline-flex shrink-0 items-center gap-1.5 text-[11px] font-semibold uppercase leading-none tracking-wider"
				:class="tone === 'program' ? 'text-error-light' : 'text-success'"
				:data-testid="`${testid}-tag`"
			>
				<span class="size-1.5 rounded-full" :class="[tone === 'program' ? 'bg-error' : 'bg-success', pulse ? 'animate-pulse' : '']" aria-hidden="true" />{{ label }}
			</span>
			<span
				class="min-w-0 truncate text-sm font-medium leading-6"
				:class="name ? 'text-surface-text-2' : 'text-surface-7'"
				:title="name || undefined"
				:data-testid="`${testid}-flow`"
			>{{ name || placeholder }}</span>
			<slot name="badges" />
		</div>
		<slot name="actions" />
	</header>
</template>
